/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {compilerService} from '../services/compiler.service';
import {animateDirective} from './animate.directive';
import {carouselDirective} from './carousel.directive';
import {intersectionDirective} from './intersection.directive';
// import {nouiSliderDirective} from './noui-slider.directive';
// import {resizeDirective} from './resize.directive';
// import {scrollDirective} from './scroll.directive';
// import {slickDirective} from './slick.directive';
// import {svgInjectDirective} from './svg-inject.directive';
import {swiperDirective} from './swiper.directive';
// import {typeaheadDirective} from './typeahead.directive';
import { videoDirective } from './video.directive';

compilerService.register('ambAnimate', animateDirective);
compilerService.register('ambCarousel', carouselDirective);
compilerService.register('ambIntersection', intersectionDirective);
// compilerService.register('ambNouiSlider', nouiSliderDirective);
// compilerService.register('ambResize', resizeDirective);
// compilerService.register('ambScroll', scrollDirective);
// compilerService.register('ambSlick', slickDirective);
// compilerService.register('ambSvgInject', svgInjectDirective);
compilerService.register('ambSwiper', swiperDirective);
// compilerService.register('ambTypeahead', typeaheadDirective);
compilerService.register('ambVideo', videoDirective);
